import { BaseDataLayer, DataLayerPlanType, PLAN_CODE_MAP, SALE_WITH_AGENT_MAP } from './base';

const baseEventParams = {
  page: '/deceso/designar-beneficiarios',
  page_title: 'Deceso - Designar Beneficiarios',
  product: 'Seguro Deceso',
  view_type: 'web',
};

const pageViewDataLayer = (plan: DataLayerPlanType, insured: string, withAgent: boolean) => ({
  ...baseEventParams,
  action_type: 'Pageview',
  product_type: plan,
  asegurados: insured,
  venta_asistida: SALE_WITH_AGENT_MAP[withAgent.toString()],
});

// const goBackClickDataLayer = (plan: DataLayerPlanType, insured: string) => ({
//   ...baseEventParams,
//   action_type: 'click',
//   product_type: plan,
//   action: 'Click - Volver',
//   asegurados: insured,
// });

// const validationModalDataLayer = (plan: DataLayerPlanType, insured: string) => ({
//   ...baseEventParams,
//   page: '/deceso/datos-de-familiares/modal-validacion-identidad',
//   action_type: 'Pageview',
//   product_type: plan,
//   asegurados: insured,
// });

// const validationAcceptClickDataLayer = (plan: DataLayerPlanType, insured: string) => ({
//   ...baseEventParams,
//   page: '/deceso/datos-de-familiares/modal-validacion-identidad',
//   action_type: 'click',
//   action: 'Click - Validar Identidad',
//   product_type: plan,
//   asegurados: insured,
// });

export const beneficiariesPageView = (planCode: string, insured: number, withAgent: boolean) =>
  BaseDataLayer({
    eventParams: pageViewDataLayer(PLAN_CODE_MAP[planCode], insured.toString(), withAgent),
  });

// export const beneficiariesGoBackClick = (planCode: string, insured: number) =>
//   BaseDataLayer({
//     eventParams: goBackClickDataLayer(PLAN_CODE_MAP[planCode], insured.toString()),
//   });

// export const beneficiariesValidationModalPageView = (planCode: string, insured: number) =>
//   BaseDataLayer({
//     eventParams: validationModalDataLayer(PLAN_CODE_MAP[planCode], insured.toString()),
//   });

// export const beneficiariesValidationAcceptClick = (planCode: string, insured: number) =>
//   BaseDataLayer({
//     eventParams: validationAcceptClickDataLayer(PLAN_CODE_MAP[planCode], insured.toString()),
//   });
